<template>
	<div class="content">
        <container v-if="!loaded"><loading /></container>
        <div class="md-layout" v-if="loaded" style="overflow-x: scroll;">
            <div class="md-layout-item md-xsmall-size-50 md-small-size-50 md-medium-size-50 md-size-50" style="margin-bottom:15px;display: flex;align-items: center;">
            	<h4 class="application-title" style="font-weight: bold;">{{translate(locale.manage_user)}}</h4>
        	</div>
			<div class="md-layout-item md-xsmall-size-50 md-small-size-50 md-medium-size-50 md-size-50 text-right" style="margin-bottom:15px">
            	<router-link :to="'/users/new'" ><md-button class="md-raised md-primary" style="padding: 0"><i class="material-icons button-icon">add_circle</i> {{translate(locale.new_user)}}</md-button></router-link>
        	</div>

			<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" style="margin-bottom:15px" v-if="loaded && user_list.length === 0">
				<container>
					<p class="text-center text-primary" style="margin: 10px 0;">{{translate(locale.no_user)}}</p>
				</container>
        	</div>

			<template v-if="user_list.length > 0">
				<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 table-item-container">
					<container>
						<div class="md-layout">
							<div class="md-layout-item md-xsmall-size-5 md-small-size-5 md-medium-size-5 md-size-5">
								<div class="table-item-text">{{translate(locale.no)}}</div>
							</div>
							<div class="md-layout-item md-xsmall-size-20 md-small-size-20 md-medium-size-20 md-size-20">
								<div class="table-item-text">{{translate(locale.code)}}</div>
							</div>
							<div class="md-layout-item md-xsmall-size-15 md-small-size-15 md-medium-size-15 md-size-15">
								<div class="table-item-text">{{translate(locale.user_and_unit)}}</div>
							</div>
							<div class="md-layout-item md-xsmall-size-25 md-small-size-25 md-medium-size-25 md-size-25">
								<div class="table-item-text">{{translate(locale.contact)}}</div>
							</div>
							<div class="md-layout-item md-xsmall-size-25 md-small-size-25 md-medium-size-25 md-size-25">
								<div class="table-item-text">{{translate(locale.permission)}}</div>
							</div>
							<div class="md-layout-item md-xsmall-size-10 md-small-size-10 md-medium-size-10 md-size-10 text-right">
								<div class="table-item-text" style="justify-content: flex-end;">{{translate(locale.action)}}</div>
							</div>
						</div>
					</container>
				</div>
				<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 table-item-container" v-for="(user, index) in user_list">
					<container>
						<div class="md-layout">
							<div class="md-layout-item md-xsmall-size-5 md-small-size-5 md-medium-size-5 md-size-5">
								<div class="table-item-text">{{index+1}}</div>
							</div>
							<div class="md-layout-item md-xsmall-size-20 md-small-size-20 md-medium-size-20 md-size-20">
								<div class="table-item-text">{{user.single_id}}<br>{{translate(config.datelify(user.created_date))}}</div>
							</div>

							<div class="md-layout-item md-xsmall-size-15 md-small-size-15 md-medium-size-15 md-size-15">
								<div class="table-item-text">{{user.name}}<br>{{user.unit_name}}</div>
							</div>
							<div class="md-layout-item md-xsmall-size-25 md-small-size-25 md-medium-size-25 md-size-25">
								<div class="table-item-text">+{{user.phone_number}}<br>{{user.email}}</div>
							</div>
							<div class="md-layout-item md-xsmall-size-25 md-small-size-25 md-medium-size-25 md-size-25">
								<div class="table-item-text">
									<template v-for="(action, index) in user.action_list">
										<template v-if="action.code != null">{{index+1}}. {{action.name}}<br></template>
										<template v-else>មិនមាន</template>
									</template>
								</div>
							</div>
							<div class="md-layout-item md-xsmall-size-10 md-small-size-10 md-medium-size-10 md-size-10 text-right">
								<router-link :to="'users/edit/' + user.hash">
									<md-button class="md-raised md-secondary"><i class="material-icons button-icon">edit</i>{{translate(locale.edit)}}</md-button>
								</router-link>
								
							</div>
						</div>
					</container>
				</div>
			</template>
        </div>
		<md-dialog-confirm :md-active.sync="deleteDialogActive" :md-title="translate(locale.deleteFormText)" :md-confirm-text="translate(locale.delete)" :md-cancel-text="translate(locale.cancel)" @md-cancel="onCancel" @md-confirm="onDelete" />
    </div>
</template>

<script>

	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.searchHandler();
		},

		data() {
			return {
				loaded: false,
				deleteDialogActive: false, deleteSelected: '',
				disableDialogActive: false, disableSelected: '',
				search: { text: "", status: "", role: "" },
				loadMore: false,
				user_list: []
			}
		},
		methods: {
			searchHandler(more = false) {
				this.$http.post(this.config.api + "/user/user/list", {
					text: this.search.text,
					status: this.search.status,
					role: this.search.role,
					offset: more ? this.user_list.length : 0
				}).then(data => {
					this.loaded = true;
					if (data.body.data.length == 100) this.loadMore = true;
					else this.loadMore = false;
					this.user_list = more ? this.user_list.concat(data.body.data) : data.body.data;
				})
			},

			showDeleteAction(id) {
				this.deleteSelected = id
				this.deleteDialogActive = true
			},
			onDelete(hash) {
				if(this.deleteSelected == "") {
					this.deleteDialogActive = true;
					this.deleteSelected = hash;
					return;
				}
				this.$http.post(this.config.api + "/admin/admin/delete", {
					hash: this.deleteSelected
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "You have deleted the quotation/bidding successfully.",
							icon: 'done',
							type: 'success'
						})
						this.searchHandler();
						this.onCancel();
					}
				})
			},
			onDisable(hash) {

				if(this.disableSelected == "") {
					this.disableDialogActive = true;
					this.disableSelected = hash;
					return;
				}
				this.$http.post(this.config.api + "/admin/admin/disable", {
					hash: this.disableSelected
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "You have disabled the quotation/bidding successfully.",
							icon: 'done',
							type: 'success'
						})
						this.searchHandler();
						this.onCancel();
					}
				})
			},

			onEnable(hash) {

				this.$http.post(this.config.api + "/admin/admin/enable", {
					hash: hash
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "You have enabled the quotation/bidding successfully.",
							icon: 'done',
							type: 'success'
						})
						this.searchHandler();
						this.onCancel();
					}
				})
			},
			onCancel() {
				this.deleteSelected = ""
				this.disableSelected = ""
				this.deleteDialogActive = false
				this.disableDialogActive = false
			},	
		}
	}
</script>
<style scoped>
	.table-item-text {
		font-weight: bold;
		color: #353690;
		display: flex;
		height: 100%;
		align-items: center;
	}
	.table-item-container {
		min-width: 1000px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Users/View.vue